import React from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from 'Components/UI/BehavioralFormElement/LabelDecorator/Floating';
import TextareaInput from 'Components/UI/BehavioralFormElement/NormalizedInput/Textarea';
import { noop } from 'Helpers/PropTypes';

const TextareaInputAlias = ({
  className, label, test, ...props
}) => (
  <FloatingLabel className={`Textarea ${className}`} label={label} test={test}>
    <TextareaInput {...props} />
  </FloatingLabel>
);

TextareaInputAlias.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  test: PropTypes.string,
};

TextareaInputAlias.defaultProps = {
  className: '',
  label: '',
  onKeyDown: noop,
  placeholder: '',
  value: '',
  test: '',
};

export default TextareaInputAlias;
